@if (isCellVisible()) {
  <div
    class="flex h-full w-full cursor-pointer py-3"
    tabindex="0"
    [id]="'table-header-' + cellName()"
    [attr.data-testid]="'table-header-' + cellName()"
    (keydown.enter)="emitSort()"
    (click)="emitSort()">
    <ng-content></ng-content>
    @if (sortParams()) {
      <span
        class="material-symbols-rounded pl-2 text-inherit"
        [class.text-input-focus]="
          sortState === SortOrder.ASC || sortState === SortOrder.DESC
        "
        style="font-size: 1.3rem">
        {{
          sortState === SortOrder.ASC
            ? 'arrow_upward_alt'
            : sortState === SortOrder.DESC
              ? 'arrow_downward_alt'
              : 'swap_vert'
        }}
      </span>
    }
  </div>
}
